export declare type THotspot = {
  coordinates: [number, number, number];
  type: string;
  title: string;
  animated?: boolean;
  delta?: number;
  image?: {
    hover: boolean;
    hotspotImage: string;
  };
  hoverElement?: HTMLElement;
};

export const hotspotImages = {
  mainImage:
    'data:image/png;base64,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',
  hoverImage:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARUSURBVHgB7ZvPbxtVEMe/89bYXixMRQUSVZ1IiEvlA1yNVMGFhCtSWi4gUEVuSKjpkUOUAxyQSLk3SBw4hfwByQUqkDB/QI04oEiWI7hQ1KQ4a5fYw8zWtuz1j9rx7tq77key1t5d2/vd997szLx5hIC4jxeyddQLDTRybCgPlhc4K4dynlMrDBwx8Ylp0j0DFG3YpYv45wQBQPARFfnQOOvEKMgPFzAFchOKhnmfQPuX4RzBJ3wRfAS70CDcmlbkMFS8xfhKhBcxJVMJDlqoF/mfisXNzUuoH+CcnEvwH7BzzxBuhyW0D8KuabotPnFXn1jwoZVet5rYkLGVxQzR1m4ytpfh7E74vfEpm/QWMX2MOUKs+85ys7Y57vljCVbrW6Xanvx8HnMJlcSi3xiniz9RsI7XJOF79D8/5wrt4vI4XHuSaDPqYFTEKvLoyjFhT3vjqPNGCk4SfYMIiG2jonXojRI9VLAaqPkds6Pg/L/m9NawowMFl2FfnzdrPAl67YdIrw885t0RpXE7CgafWExve41YXwsnDTYQcbGKOkbi9n7t3d8j+E+kVuXWXEdMUNdX/f3ufT2Cz8hsIWZocNP9uSO4dSci35W9eFu5I9h7J+JEtzbXSrcs868ICXMhi+Trr7nva3d/Rhhk2L6iaSO3hRPgVYTEc59+gpcPf8eLPxy4r7CownH9ClcwEb2DgEm/dRUv/XiAC7e/xCwQP/sN3Zr7QDaMzEV28zOk3ryK6rff4a9XriBsVKP62AkHdij+cv3uTzje+ly24YzZgdeAaiHRDCkvdbz1BWbNI1DOQJPkC4IB5SUzws9jUSDOGxnMl7EgaEChj6XYuZPD0IyIwYLxVHDcUcEVLAiauxbBHMjE81zCKpiphAWhAX4os468MILF07qXSIIrZ/5WPgwk89H7yHz4Qd9+DRmV5oMH+Pvd9xAkWj+SSKFePIONoEksL7nhoZf2vka5jKDRYhm3actk781sNj8kZGbxlxyca6b9ATFHDJY7dlzBGTg7iDkJ0L5uXcEXgRMtDUJM0R7cnmPquJZaB4WYIvZpu/2+I1iLvuLYyupOdhe09QQPcWxli01PhU+P4Ni1MmP3Eqo92f6+8PA/xk2OQUDRioz6emyf4FfhVAybyHdtrdIbVMI0MAGQw+mOxXwHEcViujOsJHFo1KBTMFVK78kpEctbU2mJT1eGHR2a4lFnJMO1NUQoI+KOW+Ybo84ZmdNS0Y8Y1xAB0b6UHipqxB6LnudEAZWeZXtlnOLSsbKWKnqJayvzaMjUQGU4vTbuopCJUx1ulR7NvpZLfQUjnmEOtYkivXMvAUhCRNNsaro0+pELvxnKEoButJCtVdsVSmu3hG5Ps7rFt2U84oNvtOso/MYPoZ3fgo9oV0+5FUG0Oq34lkhdpbbj5yq1wPKzWkDiwMk/LqngvM7N6nSl/GNv95fZAAIfM+g32ZYsSRunkCkGtRTvf6W6d2ZsMM4oAAAAAElFTkSuQmCC',
};

// Объеденяет точки пришедшие с api, и точки, которые зашиты на фронте с координатами
export type TApiSpot = {
  type: string;
  text: string;
};

export const processHotspots = (
  sourceSpots: TApiSpot[],
  spotsWithCoords: Omit<THotspot, 'title'>[]
): THotspot[] => {
  return spotsWithCoords.map(spotWithCoords => {
    const sourceSpot = sourceSpots.find(
      spot => spot.type === spotWithCoords.type
    );

    return {
      ...spotWithCoords,
      title: sourceSpot?.text || '',
      animated: true,
      delta: 55,
      image: {
        hover: false,
        hotspotImage: hotspotImages.mainImage,
      },
    };
  });
};

export const pathsToHotspots: Record<string, any> = {
  vitara: [
    'vehicles',
    { id: 'vitara' },
    'modifications',
    { id: 'novaya-vitara' },
    'grades',
    { id: 'glx' },
    'panoPoints',
  ],
  jimny: [
    'vehicles',
    { id: 'jimny' },
    'modifications',
    { id: 'all-new-jimny' },
    'grades',
    { id: 'glx' },
    'panoPoints',
  ],
  sx4: [
    'vehicles',
    { id: 'sx4' },
    'modifications',
    { id: 'sx4-fl' },
    'grades',
    { id: 'glx' },
    'panoPoints',
  ],
};

/*
 Для того, чтобы узнать координату точки нужно в PanoramaView/index.tsx в методе loadedHandler
 проставить опцию для viewer - panolens.viewer.options.output = 'console'
 Затем можно при зажатом ctrl кликать по панораме, и в консоль будут выводиться координаты
*/
export const hotspotWithCoords: Record<string, Omit<THotspot, 'title'>[]> = {
  vitara: [
    {
      type: 'side_mirrors',
      coordinates: [2651.31, -193.55, 4216.89],
    },
    {
      type: 'steering_wheel_audio',
      coordinates: [2972.5, -1155.67, 3618.41],
    },
    {
      type: 'steering_wheel_bluetooth ',
      coordinates: [3072.86, -2001.95, 3393.36],
    },
    {
      type: 'steering_wheel_gear_shift',
      coordinates: [4292.5, -1250.62, 2218.23],
    },
    {
      type: 'steering_wheel_criuze',
      coordinates: [4015.74, -1749.74, 2396.97],
    },
    {
      type: 'dashboard_LCD',
      coordinates: [4576.65, -687.39, 1870.17],
    },
    {
      type: 'window_lifters',
      coordinates: [2335.5, -2014.05, 3928.52],
    },
    {
      type: 'front_panel_analog_clock',
      coordinates: [4966.03, -530.42, -42.19],
    },
    {
      type: 'front_panel_climate',
      coordinates: [4100.24, -2850.82, -70.81],
    },
    {
      type: 'front_panel_heating_button',
      coordinates: [3351.76, -3646.02, -281.51],
    },
    {
      type: 'front_panel_multimedia',
      coordinates: [4665.94, -1719.31, -478.39],
    },
    {
      type: 'front_panel_all_wheel_button',
      coordinates: [1847.74, -4637.54, -234.6],
    },
    {
      type: 'side_door_niche',
      coordinates: [2129.45, -2967.14, -3407.24],
    },
    {
      type: 'rear_seats',
      coordinates: [-4104.59, -2659.47, 839.91],
    },
  ],
  sx4: [
    {
      type: 'side_mirrors',
      coordinates: [2651.31, -193.55, 4216.89],
    },
    {
      type: 'steering_wheel_audio',
      coordinates: [2972.5, -1155.67, 3618.41],
    },
    {
      type: 'steering_wheel_bluetooth ',
      coordinates: [3072.86, -2001.95, 3393.36],
    },
    {
      type: 'steering_wheel_gear_shift',
      coordinates: [4233.02, -1208.22, 2257.84],
    },
    {
      type: 'steering_wheel_criuze',
      coordinates: [4012.13, -1780.09, 2382.0],
    },
    {
      type: 'window_lifters',
      coordinates: [2014.66, -1949.66, 4132.12],
    },
    {
      type: 'front_panel_climate',
      coordinates: [4100.24, -2850.82, -70.81],
    },
    {
      type: 'front_panel_heating_button',
      coordinates: [3420.85, -3614.86, -241.76],
    },
    {
      type: 'front_panel_multimedia',
      coordinates: [4665.94, -1719.31, -478.39],
    },
    {
      type: 'rearview_mirror',
      coordinates: [4455.96, 2124.47, -733.87],
    },
    {
      type: 'front_panel_all_wheel_button',
      coordinates: [1957.94, -4463.04, -306.15],
    },
    {
      type: 'side_door_niche',
      coordinates: [2264.21, -2900.37, -3376.88],
    },
    {
      type: 'rear_seats_attachment',
      coordinates: [-4022.68, -2729.82, 754.64],
    },
    {
      type: 'rear_seats_backrest_adjustment',
      coordinates: [-4633.02, -419.26, 1811.75],
    },
  ],
  jimny: [
    {
      type: 'side_mirrors',
      coordinates: [3254.37, -114.42, 3783.86],
    },
    {
      type: 'steering_wheel_audio',
      coordinates: [3486.68, -1037.55, 3231.96],
    },
    {
      type: 'steering_wheel_bluetooth',
      coordinates: [3579.87, -1597.53, 3090.32],
    },
    {
      type: 'front_panel_multimedia',
      coordinates: [4930.87, -644.88, -454.6],
    },
    {
      type: 'front_panel_climate',
      coordinates: [4486.86, -2186.04, -130.87],
    },
    {
      type: 'front_panel_usb',
      coordinates: [4085.35, -2831.81, 464.68],
    },
    {
      type: 'front_panel_window_lifters_button',
      coordinates: [4182.47, -2663.77, -437.36],
    },
    {
      type: 'front_panel_assist_system',
      coordinates: [4194.55, -2677.08, -71.48],
    },
    {
      type: 'reduction_gear',
      coordinates: [2524.3, -4304.06, -273.77],
    },
    {
      type: 'seat_heating_button',
      coordinates: [1123.09, -4855.61, 3.33],
    },
    {
      type: 'rear_seats',
      coordinates: [-4234.23, -2462.92, 579.73],
    },
  ],
};
